import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { PixelRatio } from 'react-native';
import {
  SearchInput,
  Props as SearchInputProps,
} from '@/components/search-input';

export const SEARCH_BAR_VERTICAL_MARGIN = 8;
export const TEXT_INPUT_HEIGHT = 42 * PixelRatio.getFontScale();

type Props = Partial<SearchInputProps> & {
  value: string;
};

export const SearchOrderGuideInput: React.FC<Props> = ({
  containerStyle,
  ...inputProps
}) => {
  const [styles, theme] = useStyles();
  return (
    <SearchInput
      autoCorrect={false}
      containerStyle={[styles.searchInputContainer, containerStyle]}
      searchIconColor={theme.colors.inactiveText}
      {...inputProps}
    />
  );
};

const useStyles = createStyles((theme) => ({
  searchInputContainer: {
    backgroundColor: theme.colors.background,
    borderColor: theme.colors.inactiveFill,
    borderRadius: 4,
    borderWidth: 1,
    height: TEXT_INPUT_HEIGHT,
    marginHorizontal: 16,
    marginVertical: SEARCH_BAR_VERTICAL_MARGIN,
    paddingVertical: 0,
  },
}));
